import { Socket } from 'socket.io-client';
import { EventInput } from '@fullcalendar/core';
import FullCalendar from '@fullcalendar/react';
import {
  PortalStyleConfig,
  TasksListType,
  TaskSubjectDashboardFilterChanges,
  ThemeColorSchemas,
  ThemeHexColorSchemas,
} from '@nx-frontend/shared/types';
import { TasksController } from './controller';

export enum TasksViews {
  CALENDAR = 'calendar',
  TASK_LIST = 'task-list',
}

export enum CalendarViews {
  MONTH = 'dayGridMonth',
  WEEK = 'timeGridWeek',
  DAY = 'timeGridDay',
}

export interface TasksCalendarOptions {
  height?: string;
  initialView?: string;
  allowCreateNewTask?: boolean;
}

export interface TasksOptions {
  calendar?: TasksCalendarOptions;
  inputs?: Record<string, unknown>;
  outputs?: Record<string, EventListenerOrEventListenerObject>;
  showTitle?: boolean;
  defaultView?: string;
  showCreateTaskButtons?: boolean;
  editable?: boolean;
  isPortal?: boolean;
  share?: { shareId?: number; shareSecurityKey?: string };
  themeColors?: ThemeColorSchemas;
  themeStyle?: PortalStyleConfig;
  themeHexColors?: ThemeHexColorSchemas;
}

export interface TasksProps {
  featureId: string;
  workspaceId: string;
  socket?: Socket | null;
  options?: TasksOptions;
  type: TasksListType;
  controller: TasksController;
  t: (key: string) => string;
}

export interface TaskListProps {
  inputs: Record<string, unknown>;
  outputs: Record<string, EventListenerOrEventListenerObject>;
}

export type KanbanProps = TaskListProps;

export interface TasksCalendarProps {
  taskListId: string;
  workspaceId: string;
  sessionId: string;
  gatewayUrl: string;
  socket?: Socket | null;
  onRef?: (calendar: FullCalendar | null) => void;
  options?: TasksCalendarOptions;
}

export interface CalendarProps {
  featureId: string;
  workspaceId: string;
  tasks: EventInput[];
  completeTask: (taskId: string, done: boolean, workspaceId?: string) => void;
  options: TasksCalendarOptions;
  themeColors?: ThemeColorSchemas;
  themeStyle?: PortalStyleConfig;
  controller: TasksController;
  type: TasksListType;
  t: (key: string) => string;
}

export interface TasksHeaderProps {
  type: TasksListType;
  title: string;
  currentView: TasksViews;
  onChangeView: (viewType: TasksViews) => void;
  allowCreateNewTask?: boolean;
  updateTitle: (title: string) => void;
  editable?: boolean;
}

export interface CustomEventClickArg {
  event: {
    id: string;
  };
}

export interface MoreItemsPopoverProps {
  date: Date;
  tasks: EventInput[];
  pos: { x: number; y: number };
  onTaskClick: (eventInfo: CustomEventClickArg) => void;
  container: HTMLDivElement;
  completeTask: (taskId: string, done: boolean) => void;
}

export type TasksFiltersState = Omit<TaskSubjectDashboardFilterChanges, 'uniqueId' | 'tab'>;

export interface TasksRequestQueryFilters {
  labelKeys?: string[];
  assigneeUserIds?: number[];
  deadlines?: string[];
  workspaceIds: string[];
  deadlineIntervalStartMs?: number;
  deadlineIntervalEndMs?: number;
}
